import { useQuery } from '@apollo/client';
import { IAirportDetails, IFlightsByHubIdsRequestParams, IFlightsInfo } from '@transferz/fe-models/src/transitTracking/transitTracking';

import { FLIGHTS_INFO } from '../transitTrackingTypeDefs';

export const useQueryFlightsInfo = (options?: { variables: { params: IFlightsByHubIdsRequestParams | {} }, skip: boolean }) => (
  useQuery<{ flightsByHubIds: { flightDetails: IFlightsInfo[], originHubDetails: IAirportDetails } }>(FLIGHTS_INFO, options)
);
